import { i18n } from "services/i18nService";
import {
  getTransctionPdfs,
  getPrintLabelPdfs,
} from "services/sosInventoryService/sosApi";

import globalState from "globalState/globalState";

import { getObjectFromFullString } from "appConstants";

export async function generateAndDownloadPdfs(
  objectType,
  objectIds,
  templateId,
  downloadText
) {
  const pdf = await getTransctionPdfs(objectType, objectIds, templateId);
  createPdfElement(pdf, downloadText);
}

export async function generateAndDownloadPrintLabel(
  ids,
  templateId,
  downloadText
) {
  const pdf = await getPrintLabelPdfs(ids, templateId);
  createPdfElement(pdf, downloadText);
}

function createPdfElement(pdf, downloadText) {
  const a = document.createElement("a");
  a.style.display = "none";
  document.body.appendChild(a);
  a.href = window.URL.createObjectURL(pdf);
  a.setAttribute("download", downloadText);
  a.click();
  window.URL.revokeObjectURL(a.href);
  document.body.removeChild(a);
}

// Returns a PDF filename based on the object type, record IDs, and optional reference number.
// If the company's settings include a custom title for this object type (via `titleString`),
// that title is used; otherwise, a default i18n-based title is used.
export function getPdfTitle(objectType, refNumber, multiple) {
  const settings = globalState.getState().userCompanySettings.settings;
  const { titleString } = getObjectFromFullString(objectType);

  const number = refNumber ? ` ${refNumber}` : "";
  if (titleString && settings[titleString]) {
    const objectTitle = settings[titleString];
    return multiple ? `${objectTitle}.pdf` : `${objectTitle}${number}.pdf`;
  }

  return multiple
    ? `${i18n(`objectType.${objectType}.SentencePlural`)}.pdf`
    : `${i18n(`objectType.${objectType}.Sentence`)}${number}.pdf`;
}


